import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=f09083b0&scoped=true"
import script from "./Workplace.vue?vue&type=script&lang=js"
export * from "./Workplace.vue?vue&type=script&lang=js"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=f09083b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09083b0",
  null
  
)

export default component.exports